import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Public site sections
import Landing from "./pages/Landing";
import Footer from "./components/Footer";

import JunkBid from "./pages/junkbid";
import PrivateAccessForm from "./pages/privateaccessform";
import BusinessForms from "./pages/businessforms";
import SoftwareSelection from "./pages/softwareselection";
import SoftwareFormSubmission from "./pages/softwareformsubmission";
import DiagnosticForm from "./pages/diagnosticform";
import DiagnosticSubmissions from "./pages/diagnosticsubmissions";
import George from "./pages/george";
import Booking from "./pages/booking";
import OfferFormSubmissions from "./pages/offerformsubmissions";
import Pricing from "./pages/pricing";
import RevivalSystem from './pages/revivalsystem';
import AdminRevivalForms from "./pages/AdminRevivalForms";
import WebsitePricingForms from "./pages/pricingforms";
import AiDeskManager from "./pages/aideskmanager";
import SoftwareCaseStudy from "./pages/softwarecasestudy";
import ProtectedRoute from "./context/ProtectedRoute";
import Cca1 from "./pages/cca1";
import Cca2 from "./pages/cca2";
import DeskManager from "./pages/deskmanager";
import JB from "./pages/JB";
import GL from "./pages/GL";
import SoftwareCompanies from './pages/softwarecompanies';

import Signup from "./pages/Longin/Signup";
import Login from "./pages/Longin/Login";

import AdminDashboard from "./pages/AdminDashboard";
import Podcast from "./pages/podcast";
import ReflexAdvisorReviews from "./pages/reflexadvisorreviews";

// Pages
import Navbar from "./components/Navbar";
import AboutUs from "./pages/AboutUs";
import SuccessStories from "./pages/Successstories";
import FreeDownloads from "./pages/FreeDownloads";
import ContactUs from "./pages/ContactUs";
import Ourservices from "./pages/Ourservices";
import Industries from "./pages/Industries";
import Playbook from "./pages/playbook";
import Payment from "./pages/payment";
import JunkEstimator from "./pages/JunkEstimator";
import Links from "./pages/links";
import Script from "./pages/script";
import Segment from "./pages/Segment";
import Hiring from "./pages/hiring";
import HiringApply from "./pages/HiringApply";
import AdminHiring from "./pages/AdminHiring";
import AdminProfile from "./pages/AdminProfile";
import Profile from "./pages/Profile";
import UserProfile from "./pages/UserProfile";
import BusinessDirectory from "./pages/BusinessDirectory";
import BusinessProfile from "./pages/BusinessProfile";
import First30Days from "./pages/first30days";
import TorontoJunkDisposalCasestudy from "./pages/torontojunkdisposalcasestudy";
import JunkRemovalTorontoCaseStudy from "./pages/junkremovaltorontocasestudy";

// AUTH
import { AuthProvider } from "./context/AuthContext";
import { AdminAuthProvider } from "./admin/AdminAuthContext";
import AdminLogin from "./admin/AdminLogin";
import ProtectedAdminRoute from "./admin/ProtectedAdminRoute";

// BLOG
import Blog from "./pages/Blog";
import HowToGrowJunkRemovalBusiness2026_1 from "./pages/HowToGrowJunkRemovalBusiness2026_1";
import HowToGrowJunkRemovalBusiness2026_2 from "./pages/HowToGrowJunkRemovalBusiness2026_2";
import HowToGrowJunkRemovalBusiness2026_3 from "./pages/HowToGrowJunkRemovalBusiness2026_3";

// Case Studies
import CleaningCasestudy from "./pages/CleaningCasestudy";
import RoofingCasestudy from "./pages/RoofingCasestudy";
import HLCasestudy from "./pages/HLCasestudy";
import KeanuCaseStudy from "./pages/keanucasestudy";
import EquiptBizCaseStudy from "./pages/equiptbizcasestudy";
import KwikWireCaseStudy from "./pages/kwikwire";

// Profile pages
import YK from "./pages/YK";
import MK from "./pages/mk";

// Blank page
const BlankPage = () => <div style={{ minHeight: "100vh" }}></div>;

function App() {
  useEffect(() => {
    fetch("https://reflex-backend.alfaoir1.workers.dev/")
      .then(() => console.log("Visitor tracked"))
      .catch((err) => console.error("Tracking error:", err));
  }, []);

  return (
    <AuthProvider>
      <AdminAuthProvider>
        <Router>
          <Navbar />

          <Routes>

            {/* HOME */}
            <Route path="/" element={<Landing />} />

            {/* AUTH */}
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />

            {/* PUBLIC PAGES */}
            <Route path="/services" element={<Ourservices />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/success-stories" element={<SuccessStories />} />
            <Route path="/free-downloads" element={<FreeDownloads />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/industries" element={<Industries />} />
            <Route path="/junk-estimator" element={<JunkEstimator />} />
            <Route path="/links" element={<Links />} />
            <Route path="/script" element={<Script />} />
            <Route path="/segment" element={<Segment />} />
            <Route path="/hiring" element={<Hiring />} />
            <Route path="/hiring/apply" element={<HiringApply />} />
            <Route path="/admin/revival-forms" element={<AdminRevivalForms />} />
            <Route path="/admin/pricing-forms" element={<WebsitePricingForms />} />
            <Route path="/aideskmanager" element={<AiDeskManager />} />
            <Route path="/softwarecasestudy" element={<SoftwareCaseStudy />} />
            <Route path="/softwarecompanies" element={<SoftwareCompanies />} />



            <Route path="/business/:name" element={<BusinessProfile />} />
            <Route path="/pricing" element={<Pricing />} />

            
            <Route path="/junkbid" element={<JunkBid />} />

            <Route path="/private-access-form" element={<PrivateAccessForm />} />
            <Route path="/software-selection" element={<SoftwareSelection />} />
            <Route path="/diagnosticform" element={<DiagnosticForm />} />
            <Route path="/george" element={<George />} />
            <Route path="/booking" element={<Booking />} />
            <Route path="/cca1" element={<Cca1 />} />
            <Route path="/cca2" element={<Cca2 />} />
            <Route path="/deskmanager" element={<DeskManager />} />
            <Route path="/JB" element={<JB />} />
            <Route path="/GL" element={<GL />} />

            <Route path="/businesses" element={<BusinessDirectory />} />
            <Route path="/payment" element={<Payment />} />
            <Route path="/sales-playbook" element={<Playbook />} />
            <Route path="/first30days" element={<First30Days />} />
            <Route path="/podcast" element={<Podcast />} />
            <Route path="/revivalsystem" element={<RevivalSystem />} />

            <Route path="/reflexadvisorreviews" element={<ReflexAdvisorReviews />} />

            {/* LOCAL */}
            <Route path="/yk" element={<YK />} />
            <Route path="/estimator" element={<JunkEstimator />} />
            <Route path="/successstories" element={<SuccessStories />} />
            <Route path="/torontojunkdisposalcasestudy" element={<TorontoJunkDisposalCasestudy />} />
            <Route path="/junkremovaltorontocasestudy" element={<JunkRemovalTorontoCaseStudy />} />
            <Route path="/mk" element={<MK />} />

            {/* BLOG */}
            <Route path="/blog" element={<Blog />} />

            {/* PROTECTED */}
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            />
            <Route
              path="/user-profile"
              element={
                <ProtectedRoute>
                  <UserProfile />
                </ProtectedRoute>
              }
            />

            {/* ADMIN */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedAdminRoute>
                  <AdminDashboard />
                </ProtectedAdminRoute>
              }
            />
            <Route
              path="/admin/hiring"
              element={
                <ProtectedAdminRoute>
                  <AdminHiring />
                </ProtectedAdminRoute>
              }
            />
            <Route
              path="/admin/hiring/:id"
              element={
                <ProtectedAdminRoute>
                  <AdminProfile />
                </ProtectedAdminRoute>
              }
            />
            <Route
              path="/admin/diagnostic-forms"
              element={
                <ProtectedAdminRoute>
                  <DiagnosticSubmissions />
                </ProtectedAdminRoute>
              }
            />
            <Route
              path="/admin/business-forms"
              element={
                <ProtectedAdminRoute>
                  <BusinessForms />
                </ProtectedAdminRoute>
              }
            />
            <Route
              path="/admin/software-forms"
              element={
                <ProtectedAdminRoute>
                  <SoftwareFormSubmission />
                </ProtectedAdminRoute>
              }
            />
            <Route
              path="/admin/offer-forms"
              element={
                <ProtectedAdminRoute>
                  <OfferFormSubmissions />
                </ProtectedAdminRoute>
              }
            />
          </Routes>

          <Footer />
        </Router>
      </AdminAuthProvider>
    </AuthProvider>
  );
}

export default App;